<div class="feedback-manage">
    <app-spinner
    [isEnable]="isSpinnerEnable"
    loaderClass="create-process-spinner"></app-spinner>
    <app-additional-admin-features [targetTab]="'feedback'"></app-additional-admin-features>
    <div class="row">
        <div class="col-8 p-l-25 pr-0">
            <div class="card p-0 base-shadow-list fill">
                <div class="card-body chat-body">
                        <div class="height col-12">
                                <div class="height row">
                                        <div class="chat-wrap col-4 p-0">
                                            <div *ngIf="mainChatParticipant && mainChatParticipant.id" class="chat chat-nameholder" [class.chat-choosen]="isAnonymousMode" (click)="getAnonymousMessage()">
                                                <img class="default-photo" [src]="anonymPhoto">
                                                    Anonymous
                                            </div>
                                            <div class="p-0" slimScroll width="auto" height="473px" size="3px" alwaysVisible="true" class="container msg-wrap">
                                                <div *ngFor="let additionalChatParticipant of additionalParticipants">
                                                    <div class="chat" [class.chat-choosen]="selectedParticipant.id === additionalChatParticipant.id && !isAnonymousMode" (click)="selectedAdditionalParticipantFilter(additionalChatParticipant.id)">
                                                        <a class="pull-left image-companion">
                                                            <img *ngIf="additionalChatParticipant.isActive" class="media-object img-circle" [src]="additionalChatParticipant.employeePhoto">
                                                            <div [class.user-leaver]="!additionalChatParticipant.isActive"></div>
                                                        </a>
                                                        <div class="additional-participant-info">
                                                            <div *ngIf="additionalChatParticipant.isActive" class="chat-nameholder"> {{ additionalChatParticipant.displayName }} </div>
                                                            <div *ngIf="!additionalChatParticipant.isActive" class="chat-nameholder"> Leaver<span *ngIf="additionalChatParticipant.gpid">, {{ additionalChatParticipant.gpid }}</span> </div>
                                                            <div class="inactive-text"> {{ additionalChatParticipant.position }} </div>
                                                            <div class="inactive-text"> {{ additionalChatParticipant.businessUnit }} </div>
                                                        </div>
                                                    </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-8 container" style="padding:0">
                                            <div class="d-flex align-items-center chat-title">
                                                <div class="p-l-15 p-b-10 container companion-holder chat-nameholder">
                                                    <div> {{ isAnonymousMode? 'Anonymous messages' : selectedParticipant.displayName }} </div>
                                                    <div *ngIf="!selectedParticipant.isActive && selectedParticipant.gpid && !isAnonymousMode"> {{ 'Leaver, ' + selectedParticipant.gpid }} </div>
                                                </div>
                                            </div>
                                                <div slimScroll width="auto" height="473px" size="3px" alwaysVisible="true" autoScrollToBottom="true" class="chat-container container msg-wrap">
                                                    <div *ngFor="let message of displayMessages" class="media msg" [class.msg-mine]="checkMineMessage(message.personId)">
                                                        <a class="pull-left image-companion">
                                                            <img *ngIf="message.isActive || isAnonymousMode" class="media-object img-circle" [src]="getDisplayedPhoto(message)">
                                                            <div [class.user-leaver]="!message.isActive && !isAnonymousMode"></div>
                                                        </a>
                                                        <div class="media-container">
                                                            <small class="pull-right date">
                                                                <i class="fa fa-clock-o"></i> {{localeTime(message.createdDate)}}
                                                            </small>
                                                            <div *ngIf="message.isActive || isAnonymousMode" class="companion-name">{{isAnonymousMode? 'Anonym' : message.displayName}}</div>
                                                            <div *ngIf="!message.isActive && !isAnonymousMode" class="companion-name"> {{ 'Leaver, ' + message.gpid }} </div>

                                                            <div class="msg-text detail-text">
                                                                {{ message.text }}
                                                            </div>
                                                            <small class="delete-button" 
                                                                   [class.delete-anonymous-button]="isAnonymousMode"
                                                                   (click)="openApproveModal(approveModal, message)">
                                                                <i class="ti-close"></i>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="col-4 pl-4 pr-4 position-relative">
            <div class="card bg-none pl-0">
                <div class="card-body p-0">
                    <div>
                        <div class="col-12 p-0">
                            <div *ngIf="!isLeaverMode" class="mb-1">
                                Choose person / GPID:
                            </div>
                            <div *ngIf="isLeaverMode" class="mb-1">
                                Choose GPID:
                            </div>
                            <div>
                                <ngx-select [allowClear]="true"
                                            [items]="mainParticipantsSelectionItems"
                                            optionValueField="id"
                                            optionTextField="text"
                                            (remove)="clearMainParticipantFilter()"
                                            (select)="selectedMainParticipantFilter($event)"
                                            (typed)="typedMainParticipantUnitFilter($event)">
                                </ngx-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1">
                            Select period:
                        </div>
                        <input class="date-input date-imput-form"
                               #drp="bsDaterangepicker"
                               bsDaterangepicker 
                               (ngModelChange)="setDataFilter($event)" 
                               [ngModel]="bsRangeValue"
                               [bsConfig]="{ adaptivePosition: true }">
                        <i class="fa fa-calendar"
                           (click)="drp.toggle()"
                           style="position: relative;
                                  margin-left: -22px;
                                  cursor: pointer;">
                        </i>
                        <div class="col-12 mt-2 p-0">
                            <span>
                                <input type="checkbox" id="checkboxLeaver" (change)="clearMainParticipantFilter()" [(ngModel)]="isLeaverMode">
                                <label for="checkboxLeaver">Leaver</label>
                            </span>
                        </div>
                        <div class="d-flex justify-content-end m-t-20">
                            <button class="generate-report-btn" (click)="getEmployeeReport()">Generate report</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #approveModal>
    <div>
        <div class="modal-body">
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                <div>
                    Are you sure you want to delete this message?
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="deleteMessage()">Yes</span>
                <span (click)="modalRef.hide()">No</span>
            </div>
        </div>
    </div>
</ng-template>